export default __webpack_public_path__ + "static/banner-fintech-the-changing-face-of-digital-financial-management-3cf3547e8bf98d3229392dcf9b47f8d9.jpg";